import { InspectionTypeOverrides } from 'types'

const navyOverride: InspectionTypeOverrides = {
  feature: {
    plane2D: false,
  },
  annotationForm: {
    showDamageTypeSelector: true,
    showNavyLocation: true,
    annotationMenuScrollable: true,
  },
}

export default navyOverride
